import React from "react";
import { Modal, Form, Input, Button, Spin, Steps } from "antd";
import moment from "moment";
import { sub, dateFormat, formatSeconds } from "$ACTIONS/util";
import { Cookie } from "$ACTIONS/helper";
import { put } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { pwdReg } from "$ACTIONS/reg";
import { formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import Router from "next/router";
const { Item } = Form;
const { Step } = Steps;
class PassWordVerify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            userPassWord: "",
            confirmUserPwd: "",
            userPassWordError: "",
            confirmUserPwdError: "",
            btnStatus: true,
            remainingTime: "10:00",
            verificationTimedOut: false, //提示过期 modal
            firstModal: true,
        };
        this.timeTimer = null; // 倒计时Timer
        this.startCountDown = this.startCountDown.bind(this); // 倒计时
    }
    componentDidMount() {
        Cookie.Create("pwdTime", Date.now(), { expires: 10 });
        this.startCountDown();
        global.Pushgtagpiwikurl &&
            global.Pushgtagpiwikurl("reset_password_reset", "Reset Password");
    }
    componentWillUnmount() {
        Cookie.Create("pwdTime", null);
        clearInterval(this.timeTimer);
    }
    startCountDown() {
        this.setState({ remainingTime: "10:00" });
        clearInterval(this.timeTimer);
        const pwdTime = Cookie.Get("pwdTime");
        let lastSeconds = parseInt(600 - (Date.now() - pwdTime) / 1000);
        this.timeTimer = setInterval(() => {
            if (lastSeconds <= 0) {
                Cookie.Create("pwdTime", null);
                clearInterval(this.timeTimer);
                this.setState({
                    verificationTimedOut: true,
                    firstModal: false,
                });
            } else {
                this.setState({ remainingTime: formatSeconds(lastSeconds--) });
            }
        }, 1000);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        Pushgtagdata(
            "ResetPassword",
            "Submit Reset Password",
            "ResetPassword_C_Reset"
        );
        const MemberData = {
            newPassword: this.state.userPassWord,
        };
        this.setState({ isLoading: true });
        put(
            ApiPort.PUTMemberPassword + "&oldPasswordRequired=false",
            MemberData
        )
            .then((res) => {
                this.setState({ isLoading: false });
                if (res?.isSuccess == true) {
                    this.setState({
                        apiError: undefined,
                    });
                    global.showResultModal(
                        "เปลี่ยนรหัสผ่าน สำเร็จ",
                        true,
                        1501,
                        "otp"
                    ); //密码更新成功
                    Cookie.Create("pwdTime", null);
                    setTimeout(() => {
                        this.setState({ firstModal: false });

                        localStorage.setItem("login-otpPwd", true); // 驗證成功
                        Router.push("/");
                    }, 3500);
                } else {
                    if (res?.errors?.[0]?.errorCode == "VAL03016") {
                        this.setState({
                            apiError: "รหัสผ่านใหม่จะต้องไม่ซ้ำรหัสผ่านเดิม",
                        });
                    } else if (res?.errors?.length > 0) {
                        this.setState({
                            apiError: res.errors[0].description,
                        });
                    }
                }
            })
            .catch((error) => {
                console.log("updatePassword error:", error);
            });
    };
    changePassword = (e, v) => {
        if (v === "pwd") {
            this.setState({ userPassWord: e.target.value, apiError: "" });
            if (e.target.value === "") {
                this.setState({
                    userPassWordError:
                        "รหัสผ่านไม่สามารถเว้นว่างได้" /* 请确认新密码。 */,
                    btnStatus: true,
                });
            } else if (pwdReg.test(e.target.value) == false) {
                this.setState({
                    userPassWordError:
                        "รหัสผ่านต้องมีตัวอักษร a - z และตัวเลขอย่างน้อย 6-20 ตัว\n(ใส่อักขระพิเศษเช่น ^#$@ ได้)",
                    /* 密码必须包含6-20个字符，字符只限于使用字母和数字，至少包含这四个符号（^#$@）其中一个 */
                    btnStatus: true,
                });
            } else {
                this.setState({
                    userPassWordError: "",
                });
                if (e.target.value === this.state.confirmUserPwd) {
                    this.setState({
                        btnStatus: false,
                    });
                } else {
                    this.setState({ btnStatus: true });
                }
            }
            if (e.target.value === this.state.confirmUserPwd) {
                this.setState({
                    confirmUserPwdError: "",
                });
            } else if (
                this.state.confirmUserPwd &&
                e.target.value !== this.state.confirmUserPwd
            ) {
                this.setState({
                    confirmUserPwdError: "รหัสผ่านไม่ตรงกัน" /* 密码不一致 */,
                });
            }
        }

        if (v === "confirmpwd") {
            this.setState({ confirmUserPwd: e.target.value });
            if (e.target.value === "") {
                this.setState({
                    confirmUserPwdError:
                        "ยืนยันรหัสผ่านใหม่" /* 请再次确认您的密码。 */,
                    btnStatus: true,
                });
            } else if (this.state.userPassWord !== e.target.value) {
                this.setState({
                    confirmUserPwdError: "รหัสผ่านไม่ตรงกัน" /* 密码不一致 */,
                    btnStatus: true,
                });
            } else {
                if (this.state.userPassWord === e.target.value) {
                    this.setState({
                        confirmUserPwdError: "",
                        btnStatus: false,
                    });
                } else {
                    this.setState({ btnStatus: true });
                }
            }
        }
    };
    closeModal = () => {
        this.setState({ verificationTimedOut: false });
        Cookie.Create("pwdTime", null);
        global.globalExit();
    };
    render() {
        const {
            confirmUserPwdError,
            userPassWordError,
            btnStatus,
            remainingTime,
            verificationTimedOut,
            firstModal,
            apiError,
        } = this.state;
        return (
            <React.Fragment>
                {firstModal && (
                    <Modal
                        title={`เปลี่ยนรหัสผ่าน`} //更换密码
                        className="modal-pubilc OTP-modal verify-modal"
                        visible={this.props.otpPwdVisible}
                        closable={false}
                        centered={true}
                        width={400}
                        footer={null}
                        zIndex={1500}
                    >
                        <Spin spinning={this.state.isLoading}>
                            <div className="StepsBox">
                                <Steps current={1} size="small">
                                    <Step />
                                    <Step />
                                </Steps>
                            </div>

                            <Form
                                className="verification-form-wrap"
                                {...formItemLayout}
                                onSubmit={this.handleSubmit}
                            >
                                <div className="line-distance" />
                                <div className="text-tip TextLightYellow">
                                    {/* 您还有 {remainingTime} 分钟来更新新密码。
                                    请在时间结束前更改密码。 */}
                                    คุณมีเวลา {remainingTime}{" "}
                                    นาทีในการอัปเดตรหัสผ่านใหม่
                                    กรุณาเปลี่ยนรหัสผ่าน ก่อนหมดเวลา
                                </div>
                                <div className="line-distance" />
                                <Item label="รหัสผ่านใหม่">
                                    {/* 新密码 */}
                                    <Input.Password
                                        size="large"
                                        maxLength={20}
                                        placeholder="ใส่รหัสผ่านใหม่" //輸入新的密碼
                                        className={`tlc-input-disabled OTP-input ${
                                            userPassWordError && "has-error"
                                        }`}
                                        autoComplete="off"
                                        onChange={(e) =>
                                            this.changePassword(e, "pwd")
                                        }
                                    />
                                    {userPassWordError && (
                                        <p className="error-tip TextLightRed">
                                            {userPassWordError}
                                        </p>
                                    )}
                                    {apiError && (
                                        <p className="error-tip TextLightRed">
                                            {apiError}
                                        </p>
                                    )}
                                </Item>
                                <p className="TextLightGrey">
                                    รหัสผ่านต้องประกอบด้วย 6-20 ตัวอักษร
                                    อักขระพิเศษตัวอักษรและ ตัวเลข
                                    อย่างน้อยหนึ่งในสี่สัญลักษณ์นี้ (^#$@)
                                </p>
                                <Item label="ยืนยันรหัสผ่านใหม่">
                                    {/* 确认新密码 */}
                                    <Input.Password
                                        size="large"
                                        maxLength={20}
                                        placeholder="ยืนยันรหัสผ่านใหม่อีกครั้ง" //再次输入密码确认
                                        className={`tlc-input-disabled OTP-input ${
                                            confirmUserPwdError && "has-error"
                                        }`}
                                        autoComplete="off"
                                        onChange={(e) =>
                                            this.changePassword(e, "confirmpwd")
                                        }
                                    />
                                    {confirmUserPwdError && (
                                        <p className="error-tip TextLightRed">
                                            {confirmUserPwdError}
                                        </p>
                                    )}
                                </Item>
                                <Item {...tailFormItemLayout}>
                                    <div className="btn-wrap">
                                        <Button
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                            block
                                            disabled={btnStatus}
                                        >
                                            ยืนยัน{/* 更新 */}
                                        </Button>
                                    </div>
                                </Item>
                                {/* <div className="timeTip">请在 {remainingTime} 前完成密码更新。</div> */}
                            </Form>
                        </Spin>
                    </Modal>
                )}

                <Modal
                    title={`หมดเวลา`} //等待超时
                    className="modal-pubilc password-time-out"
                    visible={verificationTimedOut}
                    closable={false}
                    centered={true}
                    width={400}
                    footer={null}
                    zIndex={1500}
                >
                    <Spin spinning={this.state.isLoading}>
                        <Form
                            className="verification-form-wrap"
                            {...formItemLayout}
                            onSubmit={this.closeModal}
                        >
                            <div className={`otpPwdModal-Item`}>
                                <p className="text">
                                    การเข้าสู่ระบบของคุณหมดเวลา
                                    โปรดเข้าสู่ระบบอีกครั้ง
                                    <br />
                                    เพื่อยืนยันและอัปเดตรหัสผ่านของคุณ
                                    {/* 您该次登录已经超时，请再次登录以验证并更新密码。 */}
                                </p>
                            </div>
                            <Button
                                size="large"
                                type="primary"
                                htmlType="submit"
                                block
                            >
                                เข้าสู่ระบบ
                                {/* 重新登录 */}
                            </Button>
                        </Form>
                    </Spin>
                </Modal>
            </React.Fragment>
        );
    }
}

export default PassWordVerify;
